import React from 'react';

import Permisos from './Permisos.jsx';

const TableRow = (props) => {
    return (
        <li>
            <p className="p-permissions">{props.Programa.Title}</p>
            <ul className="no-bullets permissions">
                {props.Programa.Funciones.map(function (row, index) {
                    return <Permisos description={row.Descripcion} key={index} />;
                })}
            </ul>
        </li>
    );
}

export default TableRow;